import MaintenancePageContainer from './MaintenancePageContainer';

export default MaintenancePageContainer;
